var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1326 10.3548L13.9782 13.1796L13.978 13.1797C14.1466 13.372 14.1466 13.686 13.9535 13.8548C13.8575 13.9519 13.7369 14 13.6163 14C13.4958 14 13.3752 13.9519 13.3027 13.8793L10.4571 11.0308C9.30058 12.0444 7.82919 12.5517 6.3824 12.5517C4.76705 12.5517 3.15171 11.9237 1.94604 10.7178C-0.513265 8.25597 -0.513265 4.29666 1.94604 1.83485C3.1751 0.603443 4.79044 0 6.3824 0C7.97436 0 9.5897 0.603443 10.7954 1.83391C13.1342 4.17503 13.2547 7.89296 11.1326 10.3548ZM1.07617 6.27572C1.07617 7.6759 1.60647 9.02703 2.61903 10.0171V10.0172C3.63275 11.0308 4.98232 11.5861 6.38118 11.5861C7.78004 11.5861 9.12983 11.0308 10.1433 10.0417C11.1314 9.02694 11.6862 7.69958 11.6862 6.27572C11.6862 4.85186 11.1314 3.52429 10.1433 2.50975C9.12961 1.52069 7.8036 0.965325 6.38118 0.965325C4.95877 0.965325 3.63254 1.49616 2.61903 2.50975C1.63097 3.5245 1.07617 4.87554 1.07617 6.27572Z",
    fill: "#B4B4B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.1ce47898.svg";
export { ForwardRef as ReactComponent };